<!-- <p>expected-visitor works!</p> -->
<div class="expected-visitor-wrapper">
  <div
    [ngClass]="{
      'expected-visitor-header':
        screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
      'expected-visitor-header-mobile': screenInfo == ScreenType.Mobile
    }"
  >
    <h2>{{ tempDate | date }}</h2>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input matInput placeholder="Search by Name, Host or Purpose" (keyup)="applyFilter($event)" #input />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>
  <div
    *ngIf="filter && !filter.length"
    [ngClass]="{
      'dashboard-table-missing':
        screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
      'dashboard-table-missing-mobile': screenInfo == ScreenType.Mobile
    }"
  >
    {{ "No visitor is expected for the selected Date" }}
  </div>
  <div
    class="dashboard-table"
    *ngIf="!(filter && !filter.length) && screenInfo != ScreenType.Mobile"
  >
    <table
      mat-table
      [dataSource]="filteredDataSource"
      matSort
      multiTemplateDataRows
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
    >
      <ng-container matColumnDef="name">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.firstName + " " + row.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Date
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ getFormatedDate(row.visitDateTime) | date : "E, MMMM d, y" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="time">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Time
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ getFormatedDate(row.visitDateTime) | date : "hh:mm a" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="host">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Host
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.hostName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="purpose">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Purpose
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{
            row.purpose?.length == 0 || row.purpose?.length == null
              ? "Not Mentioned"
              : row.purpose
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="security">
        <th
          style="border-right: 1px solid"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          cdkDrag
        >
          Security
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          <button
            [ngStyle]="
              row.securityStatus == 1
                ? { 'background-color': 'green' }
                : row.securityStatus == 11
                ? { 'background-color': '#FFBF00' }
                : { 'background-color': 'red' }
            "
            class="security-button"
            mat-raised-button
          >
            {{
              row.securityStatus == 0
                ? "Unverified"
                : row.securityStatus == 11
                ? "Manually Verified"
                : "Verified"
            }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="Details">
        <th
          style="text-align: center"
          mat-header-cell
          *matHeaderCellDef
          cdkDrag
          aria-label="row actions"
        >
          Details
        </th>
        <td style="text-align: center" mat-cell *matCellDef="let element">
          <button
            [disabled]="expandedElement === element.visitorID"
            (click)="onShowDetails(element)"
            mat-raised-button
          >
            <mat-icon>{{
              expandedElement === element.visitorID ? "remove" : "add"
            }}</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr
        class="table-header"
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Row shown when there is no matching data. -->
      <div class="not-matched" *ngIf="filter && !!filter.length">
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">
            No data matching the filter "{{ input.value }}"
          </td>
        </tr>
      </div>
    </table>
  </div>
  <div class="mobile-table-card" *ngIf="screenInfo === ScreenType.Mobile">
    <app-mobile-table-card
      [visitorTableData]="filter"
      [tableType]="'visitor'"
      (showDetails)="onShowDetails($event)"
    ></app-mobile-table-card>
  </div>
</div>
